document.addEventListener("DOMContentLoaded", () => {
  //Remove empty paragraphs
  document
    .querySelectorAll(".main-article__content > div > *")
    .forEach((item) => {
      if (item.innerText.trim().length == 0) {
        item.remove();
      }
    });
});
